// src/services/turniService.js
const API_URL = 'https://www.casaletizia.net/api/turni.php';

export const fetchTurniByMonth = async (monthYear) => {
    try {
        const response = await fetch(`${API_URL}?action=get_month&month=${monthYear}`, {
            credentials: 'include'
        });
        const data = await response.json();
        if (data.success) return data.data;
        throw new Error(data.error);
    } catch (err) {
        console.error('Errore nel fetch turni', err);
        throw err;
    }
};

export const saveTurno = async (shiftData) => {
    try {
        const payload = { action: 'save_shift', ...shiftData };
        const response = await fetch(API_URL, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            credentials: 'include',
            body: JSON.stringify(payload)
        });
        const data = await response.json();
        if (data.success) return true;
        throw new Error(data.error);
    } catch (err) {
        console.error('Errore durante il salvataggio turno:', err);
        throw err;
    }
};

export const deleteTurno = async (id) => {
    try {
        const payload = { action: 'delete_shift', id };
        const response = await fetch(API_URL, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            credentials: 'include',
            body: JSON.stringify(payload)
        });
        const data = await response.json();
        if (data.success) return true;
        throw new Error(data.error);
    } catch (err) {
        console.error('Errore durante eliminazione turno:', err);
        throw err;
    }
};

export const requestFerie = async (ferieData) => {
    try {
        if (ferieData.file && (Array.isArray(ferieData.file) ? ferieData.file.length > 0 : true)) {
            const formData = new FormData();
            formData.append('action', 'request_leave');
            formData.append('start_date', ferieData.start_date);
            formData.append('end_date', ferieData.end_date);
            formData.append('motivazione', ferieData.motivazione || '');
            formData.append('operator_name', ferieData.operator_name);
            formData.append('leave_type', ferieData.type || 'Ferie');

            // Handle multiple files if it's an array
            if (Array.isArray(ferieData.file)) {
                ferieData.file.forEach(f => formData.append('files[]', f));
            } else {
                formData.append('files[]', ferieData.file); // Retro-compatibility for single file passing as multiple
                formData.append('file', ferieData.file); // Retro-compatibility
            }

            const response = await fetch(API_URL, {
                method: 'POST',
                credentials: 'include',
                body: formData
            });
            const data = await response.json();
            if (data.success) return true;
            throw new Error(data.error);
        } else {
            const payload = { action: 'request_leave', leave_type: ferieData.type || 'Ferie', ...ferieData };
            const response = await fetch(API_URL, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                credentials: 'include',
                body: JSON.stringify(payload)
            });
            const data = await response.json();
            if (data.success) return true;
            throw new Error(data.error);
        }
    } catch (err) {
        console.error('Errore richiesta ferie:', err);
        throw err;
    }
};

export const timbraTurno = async (id) => {
    try {
        const payload = { action: 'timbra_shift', id };
        const response = await fetch(API_URL, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            credentials: 'include',
            body: JSON.stringify(payload)
        });
        const data = await response.json();
        if (data.success) return true;
        throw new Error(data.error);
    } catch (err) {
        console.error('Errore durante la timbratura turno:', err);
        throw err;
    }
};

export const fetchFerieRequests = async () => {
    try {
        const response = await fetch(`${API_URL}?action=get_leave_requests`, {
            credentials: 'include'
        });
        const data = await response.json();
        if (data.success) return data.data;
        throw new Error(data.error);
    } catch (err) {
        console.error('Errore recupero richieste ferie:', err);
        throw err;
    }
};

export const updateFerieRequestStatus = async (id, status) => {
    try {
        const payload = { action: 'update_leave_status', id, status };
        const response = await fetch(API_URL, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            credentials: 'include',
            body: JSON.stringify(payload)
        });
        const data = await response.json();
        if (data.success) return true;
        throw new Error(data.error);
    } catch (err) {
        console.error('Errore aggiornamento richiesta ferie:', err);
        throw err;
    }
};
